import { createDate, importAll, transformImages } from "utils";

import AcceptanceLetterMain from "../../_hp-acceptance-letter-main";
import ReplicaContent from "components/Replicas/ReplicaContent";
import ReplicaParagraph from "components/Replicas/ReplicaParagraph";
import ReplicaQuote from "components/Replicas/ReplicaQuote";
import { ReplicaVersionType } from "types";
import background from "./background.jpg";
import thumbnail from "./thumbnail.png";

let gallery = [];

try {
  gallery = importAll(
    (require as any).context("./gallery", false, /\.(png|jpe?g|svg)$/)
  );
} catch (e) {
  console.log(e);
}

/* VERSION DATA */
export const VERSION_DATA: ReplicaVersionType = {
  isWIP: false,
  page: undefined,
  dateCreated: createDate({ day: 1, month: 5, year: 2025 }),
  datePublished: createDate({ day: 1, month: 7, year: 2025 }),
  version: "1",
  isSeries: false,
  thumbnail,
  background,
};

/* VERSION PAGE */
const Page = () => {
  return (
    <ReplicaContent>
      <ReplicaQuote source="Harry Potter and the Philosopher's Stone">
        ‘I’m a what?’ gasped Harry. ‘A wizard, o’ course,’ said Hagrid, sitting
        back down on the sofa, which groaned and sank even lower, ‘an’ a
        thumpin’ good’un, I’d say, once yeh’ve been trained up a bit. With a mum
        an’ dad like yours, what else would yeh be? An’ I reckon it’s abou’ time
        yeh read yer letter.’ Harry stretched out his hand at last to take the
        yellowish envelope, addressed in emerald green to Mr H. Potter, The
        Floor, Hut-on-the-Rock, The Sea. He pulled out the letter and read...
      </ReplicaQuote>

      <ReplicaParagraph>
        A fully readable, authentic replica of Harry Potter’s fourth (and final)
        Hogwarts acceptance letter. In the book, Harry receives this letter from
        Hagrid after he tracks down the Dursleys hiding in a shack on a remote
        rock far out at sea — their last-ditch attempt to escape the relentless
        stream of Hogwarts letters. While this letter does appear in the film,
        the envelope is never clearly shown. I believe it's the same version
        seen earlier in the movie, as I couldn’t find any other designs created
        for the first film. Since the envelope technically never appears on
        screen, I designed it entirely from scratch, using Harry’s first letter
        as a reference.
      </ReplicaParagraph>

      <AcceptanceLetterMain gallery={transformImages(gallery)} />
    </ReplicaContent>
  );
};

export default {
  ...VERSION_DATA,
  page: <Page />,
} as ReplicaVersionType;
